"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find-index");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _contract = require("@/api/cms/contract");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'ContractUrgentApply',
  components: {
    CommonUpload: _commonUpload.default
  },
  props: {
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      urgentApplyDialogVisible: false,
      urgentApplyForm: {
        applicationDetails: '',
        detailedDescription: '',
        isMaterial: '',
        isProofing: '',
        custAddress: ''
      },
      urgentApplyList: [],
      uploadedFiles: []
    };
  },
  watch: {
    contract: {
      handler: function handler(newVal) {
        if (newVal && newVal.id) {
          this.initUrgentApplyList();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 初始化加急申请列表
    initUrgentApplyList: function initUrgentApplyList() {
      var _this = this;

      if (!this.contract.id) return;
      getContractSpecialApplyList({
        contractId: this.contract.id
      }).then(function (response) {
        if (response && response.data) {
          _this.urgentApplyList = response.data;
        }
      }).catch(function (error) {
        console.error('获取加急申请列表失败:', error);

        _this.$message.error('获取加急申请列表失败，请重试');
      });
    },
    // 打开新增加急申请对话框
    openUrgentApplyDialog: function openUrgentApplyDialog() {
      this.urgentApplyForm = {
        applicationDetails: '',
        detailedDescription: '',
        isMaterial: '',
        isProofing: '',
        custAddress: ''
      };
      this.uploadedFiles = [];

      if (this.$refs.upload) {
        this.$refs.upload.clearImgs();
      }

      this.urgentApplyDialogVisible = true;
    },
    // 处理文件上传成功
    handleUploadSuccess: function handleUploadSuccess(file) {
      this.uploadedFiles.push(file);
    },
    // 处理文件移除
    handleRemove: function handleRemove(file) {
      var index = this.uploadedFiles.findIndex(function (f) {
        return f.realName === file.realName;
      });

      if (index !== -1) {
        this.uploadedFiles.splice(index, 1);
      }
    },
    // 提交加急申请
    submitUrgentApply: function submitUrgentApply() {
      var _this2 = this;

      // 表单验证
      if (!this.urgentApplyForm.applicationDetails) {
        this.$message.error('请填写申请明细');
        return;
      }

      if (!this.urgentApplyForm.detailedDescription) {
        this.$message.error('请填写明细描述');
        return;
      }

      if (!this.urgentApplyForm.isMaterial) {
        this.$message.error('请选择是否在签订回执后购买物料');
        return;
      }

      if (!this.urgentApplyForm.isProofing) {
        this.$message.error('请选择是否需要打样');
        return;
      }

      if (!this.urgentApplyForm.custAddress) {
        this.$message.error('请填写客户地址');
        return;
      } // 准备请求数据


      var formData = {
        contractId: this.contract.id,
        contractNo: this.contract.contractNo,
        applicationDetails: this.urgentApplyForm.applicationDetails,
        detailedDescription: this.urgentApplyForm.detailedDescription,
        isMaterial: this.urgentApplyForm.isMaterial,
        isProofing: this.urgentApplyForm.isProofing,
        custAddress: this.urgentApplyForm.custAddress,
        isFile: this.uploadedFiles.length > 0 ? '是' : '否',
        files: this.uploadedFiles
      }; // 调用接口

      (0, _contract.addContractUrgentApply)(formData).then(function (response) {
        if (response && response.code === 200) {
          _this2.$message.success('新增加急申请成功');

          _this2.urgentApplyDialogVisible = false;

          _this2.initUrgentApplyList();

          _this2.$emit('refresh-customer-data');
        } else {
          _this2.$message.error('新增加急申请失败，请重试');
        }
      }).catch(function (error) {
        console.error('新增加急申请失败:', error);

        _this2.$message.error('新增加急申请失败，请重试');
      });
    },
    // 获取文件预览URL
    getPreviewUrl: function getPreviewUrl(fileName, fileUrl) {
      if (fileUrl) return fileUrl;
      var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
      return filePreviewPrefix + fileName;
    }
  }
};
exports.default = _default2;